import { render } from "./XIconSolidThumbsUp.vue?vue&type=template&id=ec7724c6"
import script from "./XIconSolidThumbsUp.vue?vue&type=script&lang=js"
export * from "./XIconSolidThumbsUp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidThumbsUp.vue"]])

export default __exports__